<template>
  <v-card
    tile
    class="mb-2 rounded"
    :class="cardClasses"
    :style="cardStyle"
  >
    <v-card-text class="pa-2">
      <div
        v-if="sheet.isDelayed"
        class="d-flex align-center justify-center ga-1 text-caption bg-red-lighten-5 text-error rounded mb-1 px-2 py-1"
        style="width: 100%; line-height: 1.2;"
      >
        <v-icon
          color="error"
          size="small"
          class="flex-shrink-0"
        >
          mdi-information-outline
        </v-icon>
        <span class="d-inline-flex align-center">遅延</span>
      </div>
      <div class="d-flex justify-space-between align-start ga-2">
        <div
          class="font-weight-bold flex-grow-1"
          style="min-width: 0;"
        >
          <div class="text-caption">
            ID: {{ sheet.userId ?? "-" }}
          </div>
          <div class="text-caption text-truncate">
            {{ sheet.userName }}
          </div>
        </div>
        <v-chip
          size="x-small"
          label
          class="font-weight-bold"
          :class="sheetBadgeClasses(sheet)"
        >
          {{ statusLabel(sheet) }}
        </v-chip>
      </div>
      <div class="text-caption mt-1 text-truncate text-grey-darken-1">
        {{ sheet.complaintPreview || "-" }}
      </div>
      <div class="d-flex justify-end mt-1">
        <div
          :class="elapsedChipClasses"
          :style="elapsedChipStyle"
        >
          {{ elapsedTimeLabel(sheet) }}
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  elapsedTimeLabel,
  statusLabel,
  UI_STATUS
} from "../../utils/daytimeAdviceAssignedSheet.js";

export default {
  name: "DaytimeAdviceAssignedSheetCard",
  props: {
    sheet: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cardClasses: function() {
      return {
        "bg-light-blue-lighten-5": this.active,
      };
    },
    cardStyle: function() {
      return {
        borderStyle: "solid",
        borderColor: this.active ? "rgb(58,202,201)" : "transparent",
        borderWidth: "1px"
      };
    },
    elapsedChipClasses: function() {
      const base = ["px-2", "py-1", "rounded", "text-center"];
      return this.sheet.isDelayed
        ? [...base, "bg-red-lighten-5", "text-error"]
        : [...base, "bg-grey-lighten-4", "text-grey-darken-1"];
    },
    elapsedChipStyle: function() {
      return {
        maxWidth: "80%",
        width: "fit-content",
        fontSize: "11px",
        lineHeight: "1.2",
        whiteSpace: "normal",
        wordBreak: "break-word",
      };
    }
  },
  methods: {
    sheetBadgeClasses: function(sheet) {
      if (sheet.progress == UI_STATUS.NOT_STARTED_YET) return "bg-orange-lighten-5 text-orange-darken-4";
      if (sheet.progress == UI_STATUS.CAN_FINISH) return "bg-grey-darken-2 text-white";
      if (sheet.progress == UI_STATUS.NEED_REPLY) return "bg-grey-lighten-5 text-cyan-darken-2";

      return "bg-grey-lighten-3 text-grey-darken-2";
    },
    statusLabel,
    elapsedTimeLabel
  }
};
</script>
